import React from 'react'
import styled from 'styled-components/native'
import { useFileUpload } from './provider'
import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import Typography from 'APP/Converse/Typography'
import { Image } from 'react-native'
import Images from 'APP/Themes/Images'
import I18n from 'APP/Services/i18n'

export const ContentContainer = styled(DialogueTouchableOpacity)<{ isError: boolean}>`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: 8px;
  border-width: 1px;
  border-style: dashed;
  border-color: ${({ theme, isError }) => isError ? theme.colors.error : theme.colors.disabled};
  width: 100%;
  padding: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;  
  gap: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
  flex-grow: 1;
`

export const FileUploadContent = () => {
  const { isError, onPress, testId } = useFileUpload()

  return (
    <ContentContainer onPress={onPress} testID={testId} isError={isError}>
      <Image source={Images.fileUploadIcon} style={{ width: 40, height: 40 }}/>
      <Typography variant="bodyLarge" color='text'>
        {I18n.t('FileUploadInput.instruction')}
      </Typography>
      <Typography variant="bodySmall" color='dim'>
        {I18n.t('FileUploadInput.requirement')}
      </Typography>
    </ContentContainer>
  )
}
